<template>
  <li
    class="nav-item"
    :class="{ selected: isSelected() }"
    @mouseover="setMouseOver"
    @mouseout="unsetMouseOver"
  >
    <router-link class="link" :to="{ name: to, query: query }"
      ><slot></slot
    ></router-link>
    <span class="border"></span>
  </li>
</template>

<script>
export default {
  name: "NavItem",
  props: {
    navName: { type: String, default: "" },
    query: { type: Object, default: () => {} },
    to: { type: String, default: "" },
  },
  methods: {
    setMouseOver: function () {
      this.$parent.$parent.onMouse = this.navName;
    },
    unsetMouseOver: function () {
      this.$parent.$parent.onMouse = "";
    },
    isSelected: function () {
      return this.navName && this.$parent.$parent.onMouse === this.navName;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.nav-item {
  z-index: 1000;
  display: inline-block;
  padding-top: 11px;
  margin-left: -1.5px;
  padding-left: 3px;
  padding-right: 3px;
  &.active {
    border-bottom: 4px solid $primary;
    margin-bottom: -4px;
  }
  &:hover {
    background-color: $white;
  }
  &.active.selected {
  }
  &.selected {
    background-color: $white;
    border-top: 4px solid $primary;
    border-bottom: none;
    border-left: 1px solid $secondary;
    border-right: 1px solid $secondary;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    position: relative;
    > .link {
      padding-left: 14px;
      padding-right: 14px;
    }
    > .border {
      width: 100%;
      height: 1px;
      background-color: $white;
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 100;
    }
  }
  > .link {
    display: inline-block;
    font-size: 14px;
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 15px;
  }
  :deep(.top) {
    &.selected,
    &.selected:hover {
      color: $black;

      > .link {
        color: $black;
      }
    }
  }
}
</style>
